// Lightweight passive cart indicator for product cards.
// On page load: fetch /cart.js, mark each card whose default variant is in the cart
// with `.in-cart` class + populate the badge with the line quantity.
// Also keeps the header `<span id="Cartcount">` count in sync after add-to-cart.
// PASSIVE only — no click handling, no morph button. Decoupled from cart UX.

(function () {
  function syncFromCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // 1. Update header count badge
        var countEl = document.getElementById('Cartcount');
        if (countEl) countEl.textContent = cart.item_count || 0;

        // 2. Build map: variantId → quantity
        var qtyByVid = {};
        (cart.items || []).forEach(function (item) {
          qtyByVid[String(item.variant_id)] = (qtyByVid[String(item.variant_id)] || 0) + item.quantity;
        });

        // 3. Mark cards in cart, set badge text
        document.querySelectorAll('.wbproduct-container[data-variant-id]').forEach(function (card) {
          var vid = card.getAttribute('data-variant-id');
          var qty = qtyByVid[vid] || 0;
          var badge = card.querySelector('[data-cart-badge]');
          if (qty > 0) {
            card.classList.add('in-cart');
            if (badge) badge.textContent = qty;
          } else {
            card.classList.remove('in-cart');
            if (badge) badge.textContent = '';
          }
        });
      })
      .catch(function () {});
  }

  // Re-sync after any cart-mutating fetch (add / change / update / clear)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
      p.then(function () { setTimeout(syncFromCart, 200); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromCart);
  } else {
    syncFromCart();
  }
})();
